import React from 'react';
import AndieGenericToolRender from './AndieGenericToolRender';
import { useTranslation } from 'react-i18next';
import { ActionRenderAi } from '@/ai/types/action-render-ai';
import { PaletteRounded } from '@mui/icons-material';

type ActionResponse = { hasBranding?: boolean; source?: string } | string | null;
type ActionArgs = { privateProfileId?: string };

export type AndieGetProfileBrandingProps = ActionRenderAi<ActionResponse, ActionArgs>;

const AndieGetProfileBranding = (props: AndieGetProfileBrandingProps) => {
    const { t } = useTranslation();
    return (
        <AndieGenericToolRender<ActionResponse, ActionArgs>
            title={() => t('andie.tool.get-profile-branding.title')}
            icon={<PaletteRounded fontSize="small" />}
            privateProfileId={props.args?.privateProfileId}
            loadingMessages={() => [t('andie.tool.get-profile-branding.loading')]}
            completeMessage={() => t('andie.tool.get-profile-branding.complete')}
            {...props}
        />
    );
};

export default AndieGetProfileBranding;
